import React from 'react';
import { makeStyles, MenuItem, Popover } from '@material-ui/core';
import { Edit, TrashCan } from '@carbon/icons-react';
import { CustomizedTypography } from '@components/Customized';

interface AnnotationControlPopupProps {
  open: boolean;
  anchorRef: React.MutableRefObject<Element | null>;
  onClose: () => void;
  onDelete?: () => void;
  onEdit?: () => void;
}

const AnnotationControlPopup: React.FunctionComponent<AnnotationControlPopupProps> = ({
  open,
  anchorRef,
  onClose,
  onDelete,
  onEdit
}) => {
  const { popupPaper } = useStyles();

  return (
    <Popover
      classes={{
        paper: popupPaper
      }}
      onBackdropClick={(e) => {
        e.stopPropagation();
        onClose();
      }}
      open={open}
      anchorEl={anchorRef.current}
      anchorOrigin={{
        horizontal: 'left',
        vertical: 'bottom'
      }}
    >
      {onEdit && (
        <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            onClose();
            onEdit();
          }}
        >
          <Edit size={24} color="texetPrimary" />
          <CustomizedTypography variant="body1" color="textPrimary">
            수정하기
          </CustomizedTypography>
        </MenuItem>
      )}
      {onDelete && (
        <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            onClose();
            onDelete();
          }}
        >
          <TrashCan size={24} color="texetPrimary" />
          <CustomizedTypography variant="body1" color="textPrimary">
            삭제하기
          </CustomizedTypography>
        </MenuItem>
      )}
    </Popover>
  );
};

export default AnnotationControlPopup;

const useStyles = makeStyles((theme) => ({
  popupPaper: {
    minWidth: '242px',
    '& li': {
      height: '70px',
      padding: '16px 24px',
      display: 'flex',
      alignItems: 'center',
      gap: '12px'
    }
  }
}));
